import React from "react";
import CheckoutContext from "../../checkout-context";

class InvalidFormMessage extends React.Component {
    constructor(props) {
        super(props);
    }

    static contextType = CheckoutContext;

    render() {
        const {invalidFormMessage, textsMapping} = this.context;

        return (
            <span
                className={`form-invalid-message ${invalidFormMessage ? 'visible' : ''}`}
                onAnimationEnd={() => this.setState({invalidFormMessage: false})}
            >
                {textsMapping.genericValidationMessage}
            </span>
        )
    }
}

export {InvalidFormMessage}

